import actions from "./actions";

const initialState = {
  fetchReversalData: {
    loading: false,
    data: [],
    error: null,
    notified: false,
  },
  fetchReconData: {
    loading: false,
    data: {},
    error: null,
    notified: false,
  },
  fetchReconGCPData: {
    loading: false,
    data: {},
    error: null,
    notified: false,
  },
  uploadReconData: {
    loading: false,
    data: {},
    error: null,
    notified: false,
  },
};

export default function reconReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_REVERSAL:
      return {
        ...state,
        fetchReversalData: {
          ...state.fetchReversalData,
          loading: true,
          notified: false,
        },
      };
    case actions.FETCH_REVERSAL_SUCCESS:
      return {
        ...state,
        fetchReversalData: {
          ...state.fetchReversalData,
          loading: false,
          data: action.payload.data,
          error: null,
          notified: false,
        },
      };
    case actions.FETCH_REVERSAL_FAILURE:
      return {
        ...state,
        fetchReversalData: {
          ...state.fetchReversalData,
          loading: false,
          data: {},
          error: action.payload.error,
          notified: false,
        },
      };
    case actions.FETCH_REVERSAL_RESET:
      return {
        ...state,
        fetchReversalData: {
          ...state.fetchReversalData,
          loading: false,
          data: {},
          error: null,
          notified: false,
        },
      };
    case actions.FETCH_FILE:
      return {
        ...state,
        fetchReconData: {
          ...state.fetchReconData,
          loading: true,
          notified: false,
        },
      };
    case actions.FETCH_DATA_SUCCESS:
      return {
        ...state,
        fetchReconData: {
          ...state.fetchReconData,
          loading: false,
          data: action.payload.data,
          error: null,
          notified: false,
        },
      };
    case actions.FETCH_DATA_FAILURE:
      return {
        ...state,
        fetchReconData: {
          ...state.fetchReconData,
          loading: false,
          data: {},
          error: action.payload.error,
          notified: false,
        },
      };
    case actions.FETCH_DATA_RESET:
      return {
        ...state,
        fetchReconData: {
          ...state.fetchReconData,
          loading: false,
          data: {},
          error: null,
          notified: false,
        },
      };
    case actions.FETCH_DATA_NOTIFIED:
      return {
        ...state,
        fetchReconData: {
          ...state.fetchReconData,
          notified: true,
        },
      };

    // GCP Data Handling
    case actions.FETCH_GCP:
      return {
        ...state,
        fetchReconGCPData: {
          ...state.fetchReconGCPData,
          loading: true,
          notified: false,
        },
      };
    case actions.FETCH_GCP_SUCCESS:
      return {
        ...state,
        fetchReconGCPData: {
          ...state.fetchReconGCPData,
          loading: false,
          data: action.payload.data,
          error: null,
          notified: false,
        },
      };
    case actions.FETCH_GCP_FAILURE:
      return {
        ...state,
        fetchReconGCPData: {
          ...state.fetchReconGCPData,
          loading: false,
          data: {},
          error: action.payload.error,
          notified: false,
        },
      };
    case actions.FETCH_GCP_RESET:
      return {
        ...state,
        fetchReconGCPData: {
          ...state.fetchReconGCPData,
          loading: false,
          data: {},
          error: null,
          notified: false,
        },
      };
    case actions.FETCH_GCP_NOTIFIED:
      return {
        ...state,
        fetchReconGCPData: {
          ...state.fetchReconGCPData,
          notified: true,
        },
      };
    case actions.UPLOAD_FILE:
      return {
        ...state,
        uploadReconData: {
          ...state.uploadReconData,
          loading: true,
        },
      };
    case actions.UPLOAD_DATA_SUCCESS:
      return {
        ...state,
        uploadReconData: {
          ...state.uploadReconData,
          loading: false,
          data: action.payload.data,
          error: null,
          notified: false,
        },
      };
    case actions.UPLOAD_DATA_FAILURE:
      return {
        ...state,
        uploadReconData: {
          ...state.uploadReconData,
          loading: false,
          data: {},
          error: action.payload.error,
          notified: false,
        },
      };
    case actions.UPLOAD_DATA_RESET:
      return {
        ...state,
        uploadReconData: {
          ...state.uploadReconData,
          loading: false,
          data: {},
          error: null,
          notified: false,
        },
      };
    case actions.UPLOAD_DATA_NOTIFIED:
      return {
        ...state,
        uploadReconData: {
          ...state.uploadReconData,
          notified: true,
        },
      };
    default:
      return state;
  }
}
